import React from 'react';
import { Card, Image, Text, Badge, Group, Title, Avatar, Anchor, Box } from '@mantine/core';
import { Link, useNavigate } from 'react-router-dom';

export interface BlogCardProps {
  id: string;
  title: string;
  date: string;
  description: string;
  imageUrl: string;
  tags?: string[];
  author: {
    name: string;
    email: string;
    photoUrl: string;
  };
}

export function BlogCard({ id, title, date, description, imageUrl, tags = [], author }: BlogCardProps) {
  const navigate = useNavigate();
  return (
    <Card 
      shadow="sm" 
      padding="lg" 
      radius="md" 
      withBorder
      onClick={() => navigate(`/blog/${id}`)}
      style={{ cursor: 'pointer', transition: 'transform 0.2s ease, box-shadow 0.2s ease' }}
      className="blog-card"
    >
      <Card.Section>
        <Image
          src={imageUrl}
          height={160}
          alt={title}
        />
      </Card.Section>

      <Group justify="space-between" mt="md" mb="xs">
        <Title order={3}>{title}</Title>
        <Badge color="blue">{date}</Badge>
      </Group>

      <Text size="sm" c="dimmed" lineClamp={3}>
        {description}
      </Text>

      {tags.length > 0 && (
        <Group gap={5} mt="sm">
          {tags.map((tag) => (
            <Badge key={tag} color="gray" variant="light">
              {tag}
            </Badge>
          ))}
        </Group>
      )}
    </Card>
  );
}